import { Card, Heading, Paragraph } from "@digdir/designsystemet-react";
import type { PropsWithChildren } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Page } from "@/components";
import { SelskapForm } from "./VelgSelskapForm";

export const VelgSelskapPage = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <section className="max-w-card flex flex-col gap-6">
        <Heading level={1} data-size={"lg"}>
          {t("pages.velg-selskap.tittel")}
        </Heading>
        <Paragraph>
          <Trans
            i18nKey="pages.velg-selskap.beskrivelse"
            components={{
              Uthevd: <UthevdTekst />,
            }}
          />
        </Paragraph>

        <Card variant="tinted" className="bg-balder-background-tinted">
          <SelskapForm />
        </Card>
      </section>
    </Page>
  );
};

export const UthevdTekst = ({ children }: PropsWithChildren) => (
  <strong className="font-semibold">
    <i>{children}</i>
  </strong>
);
